
import { combineReducers } from "redux";
import loadingReducer from "./loadingReducer.ts";
import redirectreducer from "./redirectreducer.ts"
import clientSlice from "./clientSlice.ts"
import dateSlice from "./dateSlice.ts"
import regionSlice from "./regionSlice.ts"
import statusSlice from "./statusSlice.ts"
import paginationSlice from "./paginationSlice.ts"
import entitySlice from "./entitySlice.ts"
import orphanPaginationSlice from "./orphanPaginationSlice.ts"
import VenueStatusPagination from "./VenueStatusPagination.ts"
import StaffMemberUseCasePagination from "./staffMemberUseCase.ts"

const rootReducer = combineReducers({
  isLoading: loadingReducer,
  redirect:redirectreducer,
  client: clientSlice,
  date: dateSlice,
  region: regionSlice,
  status: statusSlice,
  pagination: paginationSlice,
  entity: entitySlice,
  orphanPagination: orphanPaginationSlice,
  VenueStatusPagination: VenueStatusPagination,
  StaffMemberUseCasePagination: StaffMemberUseCasePagination
  
});

export default rootReducer;
